import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Draggable from 'react-draggable';
import { useDispatch, useSelector } from "react-redux"
import * as Actions from "../../../../store/actions"
import { CircularProgress } from '@material-ui/core';
import Swal from "sweetalert2"
import { SketchPad, TOOL_PENCIL, TOOL_LINE, TOOL_RECTANGLE, TOOL_ELLIPSE, TOOL_ARROW } from '../sketchBook/index';
import io from 'socket.io-client';
import { isFirefox } from "react-device-detect"
import { VERSION_NO } from '../../../../store/actions';
import { useParams } from 'react-router-dom';
import LZUTF8 from "lzutf8"
// console.log(socket)
const socket = io("", {
    withCredentials: true,
})
// const socket = io("https://meeting.bluejayhealth.com/")


const colors = [
    'red',
    'orange',
    'cadetblue',
    'green',
    'blue',
    'indigo',
    'violet',
    'black',
    "gold"
];

const Whiteboard = props => {

    const { id } = useParams()


    const dispatch = useDispatch()


    const [IsFullScreen, setIsFullScreen] = useState(true)
    const [Position, setPosition] = useState({ x: 2, y: 10 })
    const [ButtonSelected, setButtonSelected] = useState("line")
    const [BackgroundImage, setBackgroundImage] = useState("")
    const [ImageLoading, setImageLoading] = useState(false)
    const [items, setItems] = useState([])
    const [Tool, setTool] = useState(TOOL_LINE)
    const [SelectedColor, setSelectedColor] = useState("blue")
    const [Context, setContext] = useState()
    // console.log(items)
    const meetingSession = useSelector(({ meeting }) => meeting.meetingSession)
    const baseURL = useSelector(({ utils }) => utils.baseURL);


    // useEffect(() => {
    //     window.addEventListener("resize", () => {
    //         const val = items;
    //         setItems([])
    //         setItems(val)
    //     })
    //     return () => {
    //         window.removeEventListener("resize")
    //     }
    // }, [])

    useEffect(() => {
        meetingSession?.audioVideo.realtimeSubscribeToReceiveDataMessage("BACKGROUND_IMAGE", async (dataMessage) => {
            const data = dataMessage.json()
            setBackgroundImage((prevx) => data.path)


        })



    }, [meetingSession])


    useEffect(() => {
        Context?.clearRect(0, 0, document.getElementById("containerForWhiteboard")?.clientWidth, document.getElementById("containerForWhiteboard")?.clientHeight)
        setItems((prevx) => [])
    }, [BackgroundImage])


    useEffect(() => {
        if (Context) {

            meetingSession?.audioVideo.realtimeSubscribeToReceiveDataMessage("NEW_UNDO", async (dataMessage) => {
                theUndo()
            })
        }
    }, [Context])

    useEffect(() => {

        // socket.on(`WhiteBoard=${id}`, item => {
        // // setItems((prex) => items.concat([item]))
        // setItems((prev => [...prev, item]))

        // 
        // });

        meetingSession?.audioVideo.realtimeSubscribeToReceiveDataMessage("sendItemForWhiteBoard", async (dataMessage) => {
            const data = dataMessage.data

            const backToJson = LZUTF8.decompress(data);

            const objFromJson = JSON.parse(backToJson)
            // console.log(dataMessage.data)
            // console.log(data)
            if (objFromJson.id === id) {
                setItems((prev => [...prev, objFromJson.data]))
            }

        })
    }, [meetingSession])

    useEffect(() => {
        if (IsFullScreen) {
            setPosition({ x: 2, y: 10 })
        }
    }, [IsFullScreen])


    useEffect(() => {
        if (props.ChatBoxOpen) {
            setIsFullScreen(false)
        }
    }, [props.ChatBoxOpen])


    function theUndo() {
        // setContext((prevx) => prevx)
        Context.clearRect(0, 0, document.getElementById("containerForWhiteboard")?.clientWidth, document.getElementById("containerForWhiteboard")?.clientHeight)
        setItems((prevx) => prevx.filter((x, i) => i != prevx.length - 1))
    }

    function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    return (
        // <Draggable
        //     bounds="body"
        //     disabled={IsFullScreen}
        //     position={Position}
        //     onDrag={(e, data) => {
        //         setPosition({ x: data.x, y: data.y })
        //     }}
        // >
        <div className={`myWhiteBoard ${IsFullScreen ? "big" : "small"}`}>
            {
                IsFullScreen ? null : (
                    <div className="overlay" style={{ height: "calc(100% - 35px)", width: "100%", position: "absolute", left: "0", top: "35px", zIndex: "100" }}>
                    </div>
                )
            }
            <div className="controlsNew" style={{ display: !IsFullScreen ? "none" : "" }} >
                <div className="controlsContainer">
                    <div>
                        <button
                            title="Arrow"
                            onClick={() => {
                                setTool(TOOL_ARROW)

                                setButtonSelected("arrow")
                            }}
                            className={`tool ${ButtonSelected == "arrow" ? "activeTool" : ""}`}>

                            <img src={`/images/manual/${ButtonSelected == "arrow" ? "white" : "blue"}/AArrow.svg`} />
                        </button>
                    </div>

                    <div>
                        <button
                            title="Line"
                            onClick={() => {
                                setTool(TOOL_LINE)
                                setButtonSelected("line")
                            }}
                            className={`tool ${ButtonSelected == "line" ? "activeTool" : ""}`}>
                            <img src={`/images/manual/${ButtonSelected == "line" ? "white" : "blue"}/ALine.svg`} />

                        </button>

                        {/* <p>
                                        Line
                                    </p> */}
                    </div>
                    <div>
                        <button
                            title="Circle"
                            onClick={() => {
                                setTool(TOOL_ELLIPSE)
                                setButtonSelected("circle")
                            }}
                            className={`tool ${ButtonSelected == "circle" ? "activeTool" : ""}`}>
                            <img src={`/images/manual/${ButtonSelected == "circle" ? "white" : "blue"}/ACircle.svg`} />

                        </button>
                        {/* <p>
                                        Circle
                                    </p> */}
                    </div>
                    <div>
                        <button
                            title="Square"
                            onClick={() => {

                                setTool(TOOL_RECTANGLE)

                                setButtonSelected("Square")
                            }}
                            className={`tool ${ButtonSelected == "Square" ? "activeTool" : ""}`}>
                            <img src={`/images/manual/${ButtonSelected == "Square" ? "white" : "blue"}/ASquare.svg`} />

                        </button>
                        {/* <p>
                                        Square
                                    </p> */}
                    </div>
                    <div>
                        <button
                            title="Pencil"
                            onClick={() => {

                                setTool(TOOL_PENCIL)

                                setButtonSelected("free")
                            }}
                            className={`tool ${ButtonSelected == "free" ? "activeTool" : ""}`}>
                            <img src={`/images/manual/${ButtonSelected == "free" ? "white" : "blue"}/APencil.svg`} />

                        </button>
                        {/* <p>
                                        Pen
                                    </p> */}
                    </div>
                    <div title="Attachment" style={{ display: ImageLoading ? "none" : "flex", justifyContent: "center", alignItems: "center" }}>
                        <input
                            onChange={async (e) => {
                                if (!e.target.files[0]) return
                                const fileName = e.target.files[0]?.name
                                const ext = fileName.split(".")[fileName.split(".").length - 1];

                                if (ext !== "png" && ext !== "jpg" && ext !== "jpeg" && ext !== "PNG" && ext !== "JPG" && ext !== "JPEG" && ext !== "webp" && ext !== "WEBP") {
                                    Swal.fire("Error", "This file is not supported, we only support images.", "error")
                                    return
                                }

                                setImageLoading(true)
                                const res = await dispatch(Actions.uploadFileToS3(e.target.files[0]))
                                setImageLoading(false)
                                // console.log(res)
                                const path = `${baseURL}/PT2/httpdocs/${VERSION_NO}/downloadVvChatFileV1?s3Key=${res.fileName}`
                                setBackgroundImage(path)
                                meetingSession?.audioVideo.realtimeSendDataMessage("BACKGROUND_IMAGE", JSON.stringify({
                                    path,
                                }), 100000)

                            }}
                            id="myImageUploader69"
                            type="file"
                            style={{ display: "none" }}
                        />
                        <label htmlFor="myImageUploader69" style={{ marginBottom: "0" }}>
                            <div
                                style={{ margin: "0", display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }}
                                // onClick={(e)=>e.stopPropagation()}
                                className={`tool ${ButtonSelected == "newSelection" ? "activeTool" : ""}`}>
                                <img src={`/images/manual/blue/AImage.svg`} />

                            </div>
                        </label>
                        {/* <p>
                                        Move
                                    </p> */}
                    </div>
                    {
                        ImageLoading ? <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <CircularProgress />
                        </div> : null
                    }

                    <div>
                        <button
                            title="Eraser"
                            onClick={() => {


                                setButtonSelected("Erase")
                            }}
                            className={`tool ${ButtonSelected == "Erase" ? "activeTool" : ""}`}>
                            <img src={`/images/manual/${ButtonSelected == "Erase" ? "white" : "blue"}/AEraser.svg`} />

                        </button>
                        {/* <p>
                                        Pen
                                    </p> */}
                    </div>
                    <div>
                        <button
                            title="Undo"
                            onClick={() => {
                                theUndo();
                                meetingSession?.audioVideo.realtimeSendDataMessage("NEW_UNDO", JSON.stringify({
                                    UNDO: true
                                }), 100000)

                            }}
                            className={`tool ${false ? "activeTool" : ""}`}>
                            <img src={`/images/manual/${false ? "white" : "blue"}/reload.svg`} />

                        </button>

                    </div>
                </div>
            </div>
            <div className="otherContainer">
                <div className="closeMinimizeAndColors">
                    <div className="colors" style={{ display: !IsFullScreen ? "none" : "" }}>
                        <div id="tools" style={{ display: "flex" }}>
                            <div id="colors" style={{ flexDirection: "row", justifyContent: "space-between", width: isFirefox ? "293px" : "" }} >
                                {
                                    colors.map((color, i) => {
                                        let style = {
                                            display: 'flex',
                                            backgroundColor: color,
                                            width: 20,
                                            height: 20,
                                            margin: 5,
                                            margin: 5,
                                        };
                                        let borderStyle = {
                                            display: 'flex',
                                            border: 1,
                                            border: SelectedColor === color ? '1px solid' : '',
                                            margin: 1
                                        };

                                        return (
                                            <div key={i} style={borderStyle} title={capitalizeFirstLetter(color)}>
                                                <div title={capitalizeFirstLetter(color)} style={style} onClick={() => setSelectedColor(color)}></div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                    <div className="closeETC" style={{ paddingRight: !IsFullScreen ? "42px" : "42px" }}>
                        {/* <img onClick={() => setIsFullScreen(!IsFullScreen)} src="/images/newIcons/minimize.svg" />
                                    | */}
                        <img onClick={() => props.stopWhiteboard()} src="/images/newIcons/cross.svg" />

                    </div>
                </div>
                <div id='containerForWhiteboard' className="whiteboardContainer" style={{
                    backgroundImage: `url(${BackgroundImage})`,
                    backgroundPosition: "center",
                    backgroundSize: "contain",
                    backgroundRepeat: "no-repeat",
                    display: "block",
                    cursor: ButtonSelected == "Erase" ? "url(/images/newIcons/AEraserNew.svg),auto" : ButtonSelected == "free" ? "url(/images/newIcons/newAAImage.svg),auto" : ""
                    // cursor:"pointer"

                }}>
                    {/* {console.log(items)} */}
                    <SketchPad
                        refresh={() => setItems([...items, null])}
                        getContext={(e) => setContext(e)}
                        items={items}
                        tool={ButtonSelected == "Erase" ? TOOL_PENCIL : Tool}
                        color={ButtonSelected == "Erase" ? "#fafafa" : SelectedColor}
                        size={ButtonSelected == "Erase" ? 30 : 3}
                        onCompleteItem={(i) => {
                            // console.log(JSON.stringify(i),"THIS IS WHITEBOARD DATA")
                            // socket.emit('sendItemForWhiteBoard', { id, data: i })
                            
                            const JsonString = JSON.stringify({
                                data: i,
                                id,
                            })

                            const compressedString = LZUTF8.compress(JsonString);

                            meetingSession?.audioVideo.realtimeSendDataMessage("sendItemForWhiteBoard", compressedString, 100000)
                            setItems((prev => [...items, i]))

                        }}
                        setControlBarOff={(e) => props.setControlBarOff()}
                        setControlBarOn={(e) => props.setControlBarOn()}


                    />
                </div>

            </div>
        </div>

        // {/* </Draggable> */}
    )

}

Whiteboard.propTypes = {
    open: PropTypes.bool.isRequired,
}

export default Whiteboard
